import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/role_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  name_cont: {
    model_name: 'Role',
    column_type: 'string',
    column_name: 'name',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Role',
      options: ['super', 'application', 'business_executive', 'salesman', 'channel_business_executive', 'finance', 'customer_service', 'finance_manager', 'custom', 'merchandiser'],
    },
    model_name: 'Role',
    column_name: 'kind',
  },
  kind_in: {
    column_type: 'enum',
    extra: {
      model_name: 'Role',
      options: ['super', 'application', 'business_executive', 'salesman', 'channel_business_executive', 'finance', 'customer_service', 'finance_manager', 'custom', 'merchandiser'],
    },
    model_name: 'Role',
    column_name: 'kind',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'kind': { required: true, disabledUpdate: false },
    'custom_permissions': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Role', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Role', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
